import { SelectionItem } from '../../core/component/select/select.component';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { PropertyTaxCalculationBasis } from './const/enums';

export class BuildingPropertyTaxAssessment extends ModelBase {
  constructor(dataContext?: any) {
    super();
  }

  id: string;
  buildingId: string;
  propertyTaxId: string;
  premisesTaxableValue: Money;
  premisesLandTaxableValue: Money;
  dwellingsTaxableValue: Money;
  dwellingsLandTaxableValue: Money;
  totalPremisesTaxableValue: Money;
  totalDwellingsTaxableValue: Money;
  totalSum: Money;
  area: number;
  valueYear: number;
  surface: number;

  yearSelection: SelectionItem[];

  propertyTaxPaidBy: string;
  propertyTaxCalculationBasis: PropertyTaxCalculationBasis;
  propertyTaxPercentage: number;
  calculationByObjectType: SelectionItem[];
  selectedItemForRetroDebit: SelectionItem[];
  retroDebitPeriod: SelectionItem[];
}
